<template>
<div class="UpdateUserPasswordDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="close-text-font-style margin-right-1Perc margin-Top-1Perc margin-bottom-2Perc cursor-pointer " v-on:click="openOverlay($event,false)">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right close-image-zindex-1" alt="close-icon" v-if="showClose">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2"></div>
                <div class="col-md-8 col-lg-8 new-password-policy-intro-text">
                  {{constants.New_Password_Policy_Intro_Msg}}
                </div>
                <div class="col-md-2 col-lg-2"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Old Password
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="password" class="form-control" v-model="userObj.OldPassword" id="oldPasswordId" @click="updateCurrentInputBox(1)">
                            <span class="p-viewer">
                              <i class="glyphicon glyphicon-eye-open color-orange cursor-pointer" v-if="!showOldPassword" aria-hidden="true" @click="revealPassword(1)"></i>
                              <i class="glyphicon glyphicon-eye-close color-orange cursor-pointer" v-else aria-hidden="true" @click="revealPassword(1)"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  New Password
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="password" class="form-control" v-model="userObj.NewPassword" id="newPasswordId" @click="updateCurrentInputBox(2)">
                            <span class="p-viewer">
                              <i class="glyphicon glyphicon-eye-open color-orange cursor-pointer" v-if="!showNewPassword" aria-hidden="true" @click="revealPassword(2)"></i>
                              <i class="glyphicon glyphicon-eye-close color-orange cursor-pointer" v-else aria-hidden="true" @click="revealPassword(2)"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Confirm Password
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="password" class="form-control" v-model="reEnteredPassword" id="confirmPasswordId" @click="updateCurrentInputBox(3)">
                            <span class="p-viewer">
                              <i class="glyphicon glyphicon-eye-open color-orange cursor-pointer" v-if="!showConfirmNewPassword" aria-hidden="true" @click="revealPassword(3)"></i>
                              <i class="glyphicon glyphicon-eye-close color-orange cursor-pointer" v-else aria-hidden="true" @click="revealPassword(3)"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-lg-3"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateUserPassword">Change</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
 </div>
 </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { participantService } from '@/server-util/participant-service'
export default {
  props: ['showClose'],
  created: function () {
    this.startPasswordListener()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      userObj: {
        OldPassword: '',
        NewPassword: ''
      },
      reEnteredPassword: '',
      showSpinner: false,
      isPasswordUpdated: false,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmNewPassword: false,
      currSelectedInputBox: -1,
      passwordInterval: null
    }
  },
  name: 'UpdateUserPasswordDiv',
  methods: {
    updateCurrentInputBox: function (clickedOption) {
      this.currSelectedInputBox = clickedOption
    },
    startPasswordListener: function () {
      this.passwordInterval = setInterval(() => {
        switch (this.currSelectedInputBox) {
          case 1:
            if (this.userObj.OldPassword.length === 0) {
              this.showOldPassword = false
              var x = document.getElementById('oldPasswordId')
              if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
                x.type = this.showOldPassword ? 'text' : 'password'
              } else {
                this.clearPasswordInterval()
              }
            }
            break
          case 2:
            if (this.userObj.NewPassword.length === 0) {
              this.showNewPassword = false
              x = document.getElementById('newPasswordId')
              if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
                x.type = this.showNewPassword ? 'text' : 'password'
              } else {
                this.clearPasswordInterval()
              }
            }
            break
          case 3:
            if (this.reEnteredPassword.length === 0) {
              this.showConfirmNewPassword = false
              x = document.getElementById('confirmPasswordId')
              if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
                x.type = this.showConfirmNewPassword ? 'text' : 'password'
              } else {
                this.clearPasswordInterval()
              }
            }
            break
        }
      }, 100)
    },
    revealPassword: function (selectedIcon) {
      this.currSelectedInputBox = selectedIcon
      switch (this.currSelectedInputBox) {
        case 1:
          if (this.userObj.OldPassword.length > 0) {
            this.showOldPassword = !this.showOldPassword
            var x = document.getElementById('oldPasswordId')
            if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
              x.type = this.showOldPassword ? 'text' : 'password'
            } else {
              this.clearPasswordInterval()
            }
          }
          break
        case 2:
          if (this.userObj.NewPassword.length > 0) {
            this.showNewPassword = !this.showNewPassword
            x = document.getElementById('newPasswordId')
            if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
              x.type = this.showNewPassword ? 'text' : 'password'
            } else {
              this.clearPasswordInterval()
            }
          }
          break
        case 3:
          if (this.reEnteredPassword.length > 0) {
            this.showConfirmNewPassword = !this.showConfirmNewPassword
            x = document.getElementById('confirmPasswordId')
            if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
              x.type = this.showConfirmNewPassword ? 'text' : 'password'
            } else {
              this.clearPasswordInterval()
            }
          }
          break
      }
    },
    clearPasswordInterval: function () {
      if (this.passwordInterval !== undefined && this.passwordInterval !== null) {
        clearInterval(this.passwordInterval)
      }
    },
    openOverlay: function (event, flagToUpdate) {
      if (this.showClose) {
        this.clearPasswordInterval()
        this.$emit('closeOverlay', flagToUpdate)
      }
    },
    updateUserPassword: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var storeObj = this.$store
        if (
          storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
        ) {
          // AK: Start showing Spinner
          // this.showSpinner = true
          this.$store.state.isLoading = true
          participantService
            .updateUserPassword(
              storeObj.state.access_token,
              this.userObj
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.getUpdatedUserProfile()
              } else {
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'ACCESS TOKEN is NULL hence declined UPDATE PASSWORD.'
          )
        }
      }
    },
    getUpdatedUserProfile: function () {
      var storeObj = this.$store
      var cookies2 = this.$cookies
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
      ) {
        participantService
          .getUserProfile(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide showing Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              // AK: Store it
              storeObj.state.curr_user = responseObj.data
              // console.log('After Update >>>' + JSON.stringify(responseObj.data))
              var stringifiedUserData = JSON.stringify(responseObj.data)
              cookies2.set(constants.LOGIN_USER_COOKIE, stringifiedUserData)
              localStorage.setItem(constants.LOGIN_USER_COOKIE, stringifiedUserData)
              this.autoLogoutAllClient()
              this.showAlertDialog = true
              this.errorMsg = 'Password changed successfully.'
              this.isPasswordUpdated = true
            } else {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'User Id is NULL hence declined UPDATE PASSWORD.'
        )
      }
    },
    autoLogoutAllClient: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        participantService
          .logoutFromOtherDevices(
            storeObj.state.access_token,
            constants.ClientPlatform.Admin
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              console.log('logoutFromOtherDevices Success:::')
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('logoutFromOtherDevices Error::: ' + this.errorMsg)
          })
      } else {
        console.log(
          'Access token not found hence declined UPDATE AUTO LOGOUT ALL OTHER CLIENT STATE on Server.'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isPasswordUpdated) {
        // AK: Hide Update Location Overlay
        this.clearPasswordInterval()
        this.$emit('closeOverlay', false)
        this.isPasswordUpdated = false
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.userObj.OldPassword.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Old password can\'t be empty.'
        return false
      } else if (this.userObj.NewPassword.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'New password can\'t be empty.'
        return false
      } else if (this.reEnteredPassword.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Confirm password can\'t be empty.'
        return false
      } else if (this.reEnteredPassword.trim() !== this.userObj.NewPassword.trim()) {
        this.showAlertDialog = true
        this.errorMsg = 'New password and confirm password does not match.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  watch: {}
}
</script>

<style scoped>
.new-password-policy-intro-text {
  color: #ee6b1f;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.p-viewer {
  position: relative;
  margin: -25px 10px;
  float: right;
}
.color-orange {
  color: #EE6B1F;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/UpdateUserPasswordOverlay.vue